import React, { useState } from 'react';

import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_CUSTOM_LIST_PRODUCT_DATA } from 'mocks/queries';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useClosestStoreZipcode from 'hooks/useClosestStoreZipcode';
import Placeholder from 'components/consumer/Placeholder';
import { colorBrand } from 'styles/layout/colors';
import IconMapMarker from 'components/icons/IconMapMarker';
import avo from 'analytics/avo';
import { storeUrlSlugMapping } from 'commons/ShowroomStaticData';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPShowroomModal from './PDPShowroomModal';

const PDPOnDisplayInShowroomInner = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { data: basicDetails } = usePDPBasicDetails();
  const productId = basicDetails?.id || null;

  const closestStoreLocation = useClosestStoreZipcode();
  const storeUrl = closestStoreLocation?.storeLocation?.url || null;

  const { data: showroomDisplayData, loading } = useSuspenseQuery(
    GET_CUSTOM_LIST_PRODUCT_DATA,
    {
      variables: { slug: storeUrlSlugMapping[storeUrl]?.slug },
      skip: !storeUrlSlugMapping[storeUrl]?.slug,
    }
  );

  const productsOnDisplay =
    showroomDisplayData?.getCustomListProductData?.products_list
      ?.map(item => item.id)
      .filter(Boolean) || [];
  const showText =
    !!productsOnDisplay.length && productsOnDisplay.includes(productId);

  const modalOnClose = () => {
    setModalOpen(false);
  };

  const toggleModal = () => {
    if (!modalOpen) {
      avo.ctaClicked({
        text: `On display in ${closestStoreLocation?.storeLocation?.name}`,
        targetUrl: closestStoreLocation?.storeLocation?.url,
        cta: 'Retail Store',
        component: 'Side Panel',
        location: 'PDP',
      });
    }
    setModalOpen(!modalOpen);
  };

  if (loading) {
    return (
      <Placeholder
        type="rect"
        loading
        style={{ height: '20px', marginBottom: '30px' }}
      />
    );
  }

  if (showText) {
    return (
      <div className="text-xs font-bold text-brand cursor-pointer bg-transparent border-0 pb-[5px]">
        <button
          className="text-xs font-bold text-brand cursor-pointer bg-transparent border-0 pb-[5px] text-left flex items-center"
          onClick={toggleModal}
          type="button"
          aria-label="Open Showroom"
        >
          <span className="text-xs font-bold text-gray-light2">
            On display in&nbsp;
          </span>
          <span className="text-xs font-bold text-brand hover:cursor-pointer hover:no-underline flex items-center">
            <span>
              <IconMapMarker height={12} width={12} color={colorBrand} />
            </span>
            <span className="ml-1">
              {' '}
              {closestStoreLocation?.storeLocation?.name}
            </span>
          </span>
        </button>
        {!loading && (
          <PDPShowroomModal
            data={storeUrlSlugMapping[storeUrl]?.showroom}
            onClose={modalOnClose}
            isOpen={modalOpen}
          />
        )}
      </div>
    );
  }

  return <div className="PDPOnDisplayInShowroom__filler" />;
};

const PDPOnDisplayInShowroom = props => (
  <SuspenseWithLoader>
    <PDPOnDisplayInShowroomInner {...props} />
  </SuspenseWithLoader>
);

export default PDPOnDisplayInShowroom;
